export default __webpack_public_path__ + "static/media/hht1_home_img_EP17.b0ab3240.png";